// Generated by Copilot- Start
import React from "react";
import DtvModal from "@directv-digital/dds.ui.dtv-modal";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "../../video-lab/dtv-text";
import DtvDivider from "@directv-digital/dds.ui.dtv-divider";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import Paper from "@mui/material/Paper";
import { ChannelCardV2, PackageSummary } from "lib/helper/channel-interactive-tool-v2";
import ModalChannelHeader from "./shared/ModalChannelHeader";
import ModalPackageSection from "./shared/ModalPackageSection";
import { localChannelTableStyles, dtvModalStyle, dtvModalBodyStyle, dtvModalCloseStyle, dtvModalRootSx } from "../styles/component-styles";
import { buildModalPackageLists } from "../utils/modal-package-builder";
import { parseModalContent } from "../utils/modal-content-parser";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

interface LocalChannelModalV2Props {
  open: boolean;
  channel?: ChannelCardV2;
  onClose: () => void;
  theme?: any;
  packageSummaries?: Record<string, PackageSummary>;
  chnlSrc?: string;
  dmaData?: { dma: string; nielsenDma?: string };
  genreLocalChannelMapping?: any[];
  signatureExcludedLocalChannels?: any[];
  pkgModalContent?: any;
}

const LocalChannelModalV2: React.FC<LocalChannelModalV2Props> = ({
  open,
  channel,
  onClose,
  theme: _theme,
  packageSummaries = {},
  chnlSrc,
  dmaData,
  genreLocalChannelMapping,
  signatureExcludedLocalChannels,
  pkgModalContent
}) => {
  try {
    if (!channel) {
      return null;
    }

    // Build package lists using centralized utility
    const { signaturePackageList: signaturePackages, genrePackageList: genrePackages } = buildModalPackageLists("local", {
      channel,
      packageSummaries,
      chnlSrc,
      dmaData,
      genreLocalChannelMapping,
      signatureExcludedLocalChannels
    });

    // Determine if this is satellite variant
    const isSatellite = chnlSrc === "dtvClup";

    // Parse CMS content using centralized helper with package counts for singular/plural
    const { signaturePkgTxt, genrePkgTxt } = parseModalContent(pkgModalContent, isSatellite);

    return (
      <DtvModal
        open={open}
        handleClose={onClose}
        modalStyle={dtvModalStyle}
        modalBodyStyle={dtvModalBodyStyle}
        sx={dtvModalRootSx}
        {...dtvModalCloseStyle}
      >
        <DtvBox sx={{
 display: "flex",
flexDirection: "column",
p: "1px"
}}>
          {/* Channel Header */}
          <ModalChannelHeader logo={channel.logo} label={channel.label} />

          <DtvDivider sx={{
 my: {
 xs: "18px",
md: "21px"
}
}} />

          {/* Local Channels Table */}
          <DtvText
            variant="subhead2medium"
            content="Local Channels"
            sx={{
              fontSize: "20px !important",
              mb: {
 xs: "16px",
sm: "21px"
}
            }}
          />

          <DtvGrid container sx={{
 mb: {
 xs: "16px",
sm: "21px"
}
}}>
            {/* Table Header */}
            <DtvGrid container item xs={12}>
              <DtvGrid item xs={6}>
                <Paper
                  elevation={0}
                  square
                  sx={{
                    ...localChannelTableStyles.commonCell,
                    ...localChannelTableStyles.headerCell,
                    ...localChannelTableStyles.headerLeftCell
                  }}
                >
                  <DtvText variant="body1medium" content="Affiliates" sx={localChannelTableStyles.headerText} />
                </Paper>
              </DtvGrid>
              <DtvGrid item xs={6}>
                <Paper
                  elevation={0}
                  square
                  sx={{
                    ...localChannelTableStyles.commonCell,
                    ...localChannelTableStyles.headerCell,
                    ...localChannelTableStyles.headerRightCell
                  }}
                >
                  <DtvText variant="body1medium" content="Channel No" sx={localChannelTableStyles.headerText} />
                </Paper>
              </DtvGrid>
            </DtvGrid>

            {/* Table Body */}
            <DtvGrid container item xs={12} sx={{ backgroundColor: "#F4F4F4" }}>
              <DtvGrid item xs={6}>
                <Paper
                  elevation={0}
                  square
                  sx={{
                    ...localChannelTableStyles.commonCell,
                    ...localChannelTableStyles.bodyCell,
                    ...localChannelTableStyles.bodyLeftCell
                  }}
                >
                  <DtvText variant="body2" content={channel.rawData?.callSign || channel.label} sx={localChannelTableStyles.bodyText} />
                </Paper>
              </DtvGrid>
              <DtvGrid item xs={6}>
                <Paper
                  elevation={0}
                  square
                  sx={{
                    ...localChannelTableStyles.commonCell,
                    ...localChannelTableStyles.bodyCell,
                    ...localChannelTableStyles.bodyRightCell
                  }}
                >
                  <DtvText
                    variant="body2"
                    content={channel.rawData?.channelNumber != null && !isNaN(Number(channel.rawData.channelNumber)) ? `Channel ${channel.rawData.channelNumber}` : "-"}
                    sx={localChannelTableStyles.bodyText}
                  />
                </Paper>
              </DtvGrid>
            </DtvGrid>
          </DtvGrid>

          {/* Signature Packages Section */}
          <ModalPackageSection
            id="package-mapping-with-channel"
            heading={signaturePkgTxt}
            packages={signaturePackages}
            channelName={channel.label}
            channelCategory="local"
            topMargin="0px"
          />

          {/* Genre Packages Section */}
          <ModalPackageSection
            id="package-mapping-with-channel-genre"
            heading={genrePkgTxt}
            packages={genrePackages}
            channelName={channel.label}
            channelCategory="local"
            showDivider={signaturePackages.length > 0}
            topMargin="26px"
          />
        </DtvBox>
      </DtvModal>
    );
  } catch (error) {
    console.error("Error in LocalChannelModalV2 >> ", error);
    return <ErrorDisplay error={error} component="Local Channel Modal V2" />;
  }
};

export default React.memo(LocalChannelModalV2);
// Generated by Copilot- End
